import React from "react";

// Uses country-flag-icons package which provides SVG flags per ISO 3166-1 alpha-2 code.
// Each country is a subdirectory under country-flag-icons/react/3x2/<CODE>/index.js
// This ensures consistent rendering on all OSes without relying on OS emoji support.

// Pre-import the flags we use to avoid dynamic require issues with bundlers
import US from "country-flag-icons/react/3x2/US";
import IN from "country-flag-icons/react/3x2/IN";

const FLAG_MAP = { US, IN };

const CountryFlag = ({ countryCode, size = 20, style = {} }) => {
  const FlagSvg = FLAG_MAP[countryCode];

  if (!FlagSvg) {
    return (
      <span style={{ fontSize: size * 0.65, fontWeight: 600, ...style }}>
        {countryCode}
      </span>
    );
  }

  return (
    <FlagSvg
      style={{
        width: size * 1.33,
        height: size,
        borderRadius: 2,
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
        ...style,
      }}
      title={countryCode}
    />
  );
};

export default CountryFlag;
